import * as React from 'react'
import styled from 'styled-components'

import * as glyphs from '../icons/glyphs'
import * as S from '../styles'

const ICONS = {
  bandcamp: glyphs.thirdParty.Bandcamp,
  bluesky: glyphs.thirdParty.Bluesky,
  dailymotion: glyphs.thirdParty.Dailymotion,
  discord: glyphs.thirdParty.Discord,
  email: glyphs.stroke.Letter,
  facebook: glyphs.thirdParty.Facebook,
  instagram: glyphs.thirdParty.Instagram,
  linkedin: glyphs.thirdParty.Linkedin,
  linktree: glyphs.thirdParty.Linktree,
  mastodon: glyphs.thirdParty.Mastodon,
  soundcloud: glyphs.thirdParty.Soundcloud,
  spotify: glyphs.thirdParty.Spotify,
  threads: glyphs.thirdParty.Threads,
  tiktok: glyphs.thirdParty.Tiktok,
  tumblr: glyphs.thirdParty.Tumblr,
  twitch: glyphs.thirdParty.Twitch,
  twitter: glyphs.thirdParty.Twitter,
  vimeo: glyphs.thirdParty.Vimeo,
  website: glyphs.thirdParty.WebsiteLink,
  youtube: glyphs.thirdParty.Youtube,
}

export type SquarePlatformIconProps = {
  className?: string
  platform: keyof typeof ICONS
  size?: number
}

function SquarePlatformIconComponent({
  className,
  platform,
  size = 21.5,
}: SquarePlatformIconProps): React.ReactElement {
  //handle cases when platform sent by API is unknown
  const overridePlatform = ICONS[platform] ? platform : 'website'

  const PlatformIcon = ICONS[overridePlatform]

  return (
    <S.squarePlatformIcon.Square className={className} $platform={overridePlatform} $size={size}>
      <PlatformIcon size={size} />
    </S.squarePlatformIcon.Square>
  )
}

export const SquarePlatformIcon = styled(SquarePlatformIconComponent)``
